const domainListBox = document.querySelector('.domain-list-box')
const auctionsList = document.querySelector('.auctions-list')

let domainListArray = []

/**
 * Initialize rotating domain banner.
 * @param {Object} options
 * @param {number} [options.pause=0] - Pause between domain transitions (ms).
 * @param {number} [options.typeSpeed=150] - Speed of typing each character (ms).
 * @param {number} [options.deleteSpeed=150] - Speed of deleting each character (ms).
 */
const initDomainsBanner = ({ pause = 1000, typeSpeed = 150, deleteSpeed = 150 } = {}) => {
    // Exit if required DOM elements do not exist
    if (!domainListBox || !auctionsList) return

    // Select auction lists
    const auctionsListIn = auctionsList.querySelector('.auctions-list.in_auction')
    const auctionsListNew = auctionsList.querySelector('.auctions-list.new')

    // Add domains from ongoing auctions
    if (auctionsListIn) {
        auctionsListIn.querySelectorAll('tbody tr td:first-of-type a').forEach(item => {
            domainListArray.push(item.textContent)
        })
    }

    // If fewer than 6 domains, add from new auctions
    if (domainListArray.length < 6 && auctionsListNew) {
        auctionsListNew.querySelectorAll('tbody tr td:first-of-type a').forEach(item => {
            domainListArray.push(item.textContent)
        })
    }

    // Remove domains that match any item in data-domain-list-block
    const domainListBlock = document.querySelector('div[data-domain-list-block]')
    if (domainListBlock) {
        const domainListBlockArray = domainListBlock.dataset.domainListBlock
            .split(', ')
            .map(item => item.trim())
        domainListArray = domainListArray.filter(
            domain => !domainListBlockArray.some(blockItem => domain.includes(blockItem)),
        )
    }

    // Add extra domains from data-domain-list-add if not already present
    const domainListAdd = document.querySelector('div[data-domain-list-add]')
    if (domainListAdd) {
        const domainListAddArray = domainListAdd.dataset.domainListAdd
            .split(', ')
            .map(item => item.trim())
        domainListArray = [...domainListArray, ...domainListAddArray.filter(
            domain => !domainListArray.includes(domain))]
    }

    // Remove duplicates
    domainListArray = [...new Set(domainListArray)]

    // Helper: wait for a specified time
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

    // Animate removing text from the element one character at a time
    const removeLastLetter = (element) => {
        return new Promise((resolve) => {
            let text = element.textContent

            function step() {
                if (text.length > 0) {
                    text = text.slice(0, -1)
                    element.textContent = text
                    setTimeout(step, deleteSpeed) // Control delete speed here
                } else {
                    resolve()
                }
            }

            step()
        })
    }

    // Animate adding text to the element one character at a time
    const addLettersOneByOne = (element, newText) => {
        return new Promise((resolve) => {
            let index = 0
            element.textContent = ''

            function step() {
                if (index < newText.length) {
                    element.textContent += newText[index]
                    index++
                    setTimeout(step, typeSpeed) // Control typing speed here
                } else {
                    resolve()
                }
            }

            step()
        })
    }

    // Main loop to rotate domain names
    const startDomainRotation = async(element) => {
        while (true) {
            const randomDomain = domainListArray[Math.floor(Math.random() * domainListArray.length)]
            await removeLastLetter(element)
            if (pause > 0) await wait(pause / 4) // Optional small pause after delete
            await addLettersOneByOne(element, randomDomain)
            if (pause > 0) await wait(pause) // Optional pause after writing
        }
    }

    const spanElement = domainListBox.querySelector('strong')
    if (spanElement && domainListArray.length > 0) {
        startDomainRotation(spanElement)
    }
}

export { initDomainsBanner }
